<template>
  <div>
    <div class="product1">
      <div class="productBanner">
        <div class="module">
          <div class="h1">ZTMapGIS</div>
          <div class="line"></div>
          <div class="h2">二三维GIS地理信息平台</div>
          <div class="p">轻松实现传统二维地图应用在线离线一体化解决方案成熟SDK支持快速定制开发</div>
        </div>
        <div class="img"></div>
      </div>
      <div class="overview">
        <div class="module">
          <div class="productTitle">
            概述
            <span>/Overview</span>
          </div>
          <div
            class="p"
          >ZTMapGIS系列二三维GIS地理信息可视化平台软件，是臻图信息自主研发的一款企业级空间GIS地理信息可视化软件。ZTMapGIS是一款轻量级空间数据可视化平台软件，提供B/S结构的WEBGIS开发框架、Android、IOS等移动平台开发框架；基于该平台可以轻松实现功能丰富的二维地图、三维地图一体化集成发布；实现在线、离线一体化应用解决方案。</div>
        </div>
      </div>
      <div class="function">
        <div class="productTitle">
          功能简介
          <span>/Function</span>
        </div>
        <div class="functionbg">
          <div class="module">
            <div class="list">
              <div>
                <div class="left">01</div>
                <div class="right">
                  <div class="title">基础功能</div>
                  <div class="p">地图的基本浏览，包括地图全图、缩放、拖动、测距、测面积、影像图、刷新等常见功能</div>
                </div>
              </div>
              <div>
                <div class="left">02</div>
                <div class="right">
                  <div class="title">查询功能</div>
                  <div class="p">基础图层查询、POI查询、模糊查询、属性查询、关联查询、周边查询等</div>
                </div>
              </div>
              <div>
                <div class="left">03</div>
                <div class="right">
                  <div class="title">二三维一体化渲染</div>
                  <div class="p">实现2D、2.5D、3D多种地图形式的无缝集成渲染展示</div>
                </div>
              </div>
              <div>
                <div class="left">04</div>
                <div class="right">
                  <div class="title">室内外一体化渲染</div>
                  <div class="p">实现室外地图和室内地图无缝渲染切换</div>
                </div>
              </div>
              <div>
                <div class="left">05</div>
                <div class="right">
                  <div class="title">空间分析</div>
                  <div class="p">缓冲区分析、路径分析、地理编码、公交换乘分析等</div>
                </div>
              </div>
              <div>
                <div class="left">06</div>
                <div class="right">
                  <div class="title">互联网地图在线集成</div>
                  <div class="p">实时调用集成谷歌、高德、百度等互联网地图，以统一的接口提供开发应用</div>
                </div>
              </div>
              <div>
                <div class="left">07</div>
                <div class="right">
                  <div class="title">互联网地图离线应用</div>
                  <div class="p">离线集成谷歌、高德、百度等互联网地图数据，集成到本地ZTMapGIS平台，实现本地化地图应用</div>
                </div>
              </div>
              <div>
                <div class="left">08</div>
                <div class="right">
                  <div class="title">室内地图应用</div>
                  <div class="p">实现商场、展览馆、停车场等室内地图的绘制、渲染、导航、人流分析等功能</div>
                </div>
              </div>
              <div>
                <div class="left">09</div>
                <div class="right">
                  <div class="title">大数据应用</div>
                  <div class="p">能够无缝对接Hadoop、Spark等主流大数据平台，兼容HDFS、HBase、Hive等大数据主流数据协议和接口</div>
                </div>
              </div>
              <div>
                <div class="left">10</div>
                <div class="right">
                  <div class="title">AI（人工智能）应用</div>
                  <div class="p">将聚类算法、回归算法、卷积网络等主流AI算法的理念和算法能力应用于空间数据分析中，以AI为空间信息应用赋能</div>
                </div>
              </div>
              <div>
                <div class="left">11</div>
                <div class="right">
                  <div class="title">VR/AR集成应用</div>
                  <div class="p">结合GIS空间渲染和三维渲染的技术优势，融入AR技术，实现增强现实的行业应用</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="productTitle">
          效果图
          <span>/Rendering</span>
        </div>
        <div class="module">
          <div class="list">
            <div v-for="(item,index) in 4" :key="index"></div>
          </div>
        </div>
      </div>
      <div class="characteristics">
        <div class="productTitle">
          技术特点
          <span>/Characteristics</span>
        </div>
        <div class="characteristicsbg">
          <div class="module">
            <div>
              <div>
                <div class="y"></div>面向应用的丰富地图应用功能
              </div>
              <div>
                <div class="y"></div>符合行业国际标准的地图服务
              </div>
              <div>
                <div class="y"></div>多源数据集成与海量数据快速访问
              </div>
            </div>
            <div>
              <div>
                <div class="x"></div>
              </div>
              <div>
                <div class="x"></div>
              </div>
              <div>
                <div class="x"></div>
              </div>
            </div>
            <div>
              <div>
                <div class="y"></div>第三方地图平台集成能力
              </div>
              <div>
                <div class="y"></div>免插件WEBGL三维轻量化引擎
              </div>
              <div>
                <div class="y"></div>客户端与服务器多级缓存结构
              </div>
            </div>
            <div>
              <div>
                <div class="x"></div>
              </div>
              <div>
                <div class="x"></div>
              </div>
              <div>
                <div class="x"></div>
              </div>
            </div>
            <div>
              <div>
                <div class="y"></div>跨平台架构，多平台部署能力
              </div>
              <div>
                <div class="y"></div>便利易用的应用开发接口
              </div>
              <div>
                <div class="y"></div>可扩展动态群集，具有高度伸缩性
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="application">
        <div class="module">
          <div class="productTitle">
            行业应用
            <span>/Application</span>
          </div>
          <div class="list">
            <div>
              智慧园区
              <div class="c">A</div>
            </div>
            <div>
              智慧安防
              <div class="c">B</div>
            </div>
            <div>
              智慧社区
              <div class="c">C</div>
            </div>
            <div>
              智慧环保
              <div class="c">D</div>
            </div>
            <div>
              公共安全
              <div class="c">E</div>
            </div>
            <div>
              应急指挥
              <div class="c">F</div>
            </div>
            <div>
              指挥场馆
              <div class="c">G</div>
            </div>
            <div>
              智慧建筑
              <div class="c">H</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-product1">
      <div class="product-title">
        <div class="title-content">
          <div class="title">ZTMapGIS</div>
          <div class="line"></div>
          <div class="p">
            二三维GIS地理信息平台
          </div>
          <div class="span">
            轻松实现传统二维地图应用在线离线一体化解决方案成熟SDK支持快速定制开发
          </div>
        </div>
        <div class="img">
          <img src="../../assets/images/index/banner_img1.png" alt="">
        </div>
      </div>
      <div class="part">
        <div class="part-title">概述</div>
        <div class="en-title">OVERVIEW</div>
        <div class="overview-content">
          ZTMapGIS系列二三维GIS地理信息可视化平台软件，是臻图信息自主研发的一款企业级空间GIS地理信息可视化软件。ZTMapGIS是一款轻量级空间数据可视化平台软件，提供B/S结构的WEBGIS开发框架、Android、IOS等移动平台开发框架；基于该平台可以轻松实现功能丰富的二维地图、三维地图一体化集成发布；实现在线、离线一体化应用解决方案。
        </div>
      </div>
      <div class="part function">
        <div class="part-title">功能简介</div>
        <div class="en-title">FUNCTION</div>
        <div class="content">
          <div class="item" v-for="item in functionList" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="part-title">效果图</div>
        <div class="en-title">RENDERING</div>
        <div class="swiper">
          <el-carousel class="case-carousel" indicator-position="outside" height="23rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`product1-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div> 
      <div class="characteristics">
        <div class="part-title">技术特点</div>
        <div class="en-title">CHARACTERISTICS</div>
        <div class="content">
          <div class="item">
            <div>
              <p>1.1</p>
              <span>面向应用的丰富地图应用功能</span>
            </div>
            <div>
              <p>1.2</p>
              <span>第三方地图平台集成能力</span>
            </div>
            <div>
              <p>1.3</p>
              <span>跨平台架构，多平台部署能力</span>
            </div>
            
          </div>
          <div class="item">
            <div>
              <p>2.1</p>
              <span>符合行业国际标准的地图服务</span>
            </div>
            <div>
              <p>2.2</p>
              <span>免插件WEBGL三维轻量化引擎</span>
            </div>
            <div>
              <p>2.3</p>
              <span>便利易用的应用开发接口</span>
            </div>
            
          </div>
          <div class="item3">
            <div>
              <p>3.1</p>
              <span>多源数据集成与海量数据快速访问</span>
            </div>
            <div>
              <p>3.2</p>
              <span>客户端与服务器多级缓存结构</span>
            </div>
            <div>
              <p>3.3</p>
              <span>可扩展动态群集，具有高度伸缩性</span>
            </div>
            
          </div>
        </div>
      </div>
      <div class="part">
        <div class="part-title">行业应用</div>
        <div class="en-title">APPLICATION</div>
        <div class="application-content">
          <div class="item item1">智慧园区</div>
          <div class="item item2">智慧安防</div>
          <div class="item item3">智慧社区</div>
          <div class="item item4">智慧环保</div>
          <div class="item item5">公共安全</div>
          <div class="item item6">应急指挥</div>
          <div class="item item7">指挥场馆</div>
          <div class="item item8">智慧建筑</div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'Product1',
  metaInfo: {
    title: '二三维GIS平台_3D-GIS_地理信息系统_二三维地图系统_三维地图引擎_ZTMapGIS-上海臻图信息技术有限公司',
    meta: [
      {
        name: 'keywords',
        content:
          '三维GIS,3DGIS,3D-GIS,三维地图引擎,三维GIS引擎,地图可视化引擎,地理信息系统'
      },
      {
        name: 'description',
        content:
          'ZTMapGIS系列二三维GIS地理信息可视化平台软件,是臻图信息自主研发的一款企业级空间GIS地图可视化引擎软件,是一款轻量级空间数据可视化平台软件,提供B/S结构的WEBGIS开发框架、Android、IOS等移动平台开发框架；基于该平台可以轻松实现功能丰富的二维地图、三维地图一体化集成发布。'
      }
    ]
  },
  data () {
    return {
      functionList: [
        {
          id: 1,
          title: '基础功能',
          content: '地图的基本浏览，包括地图全图、缩放、拖动、测距、测面积、影像图、刷新等常见功能'
        },
        {
          id: 2,
          title: '查询功能',
          content: '基础图层查询、POI查询、模糊查询、属性查询、关联查询、周边查询等'
        },
        {
          id: 3,
          title: '二三维一体化渲染',
          content: '实现2D、2.5D、3D多种地图形式的无缝集成渲染展示'
        },
        {
          id: 4,
          title: '室内外一体化渲染',
          content: '实现室外地图和室内地图无缝渲染切换'
        },
        {
          id: 5,
          title: '空间分析',
          content: '缓冲区分析、路径分析、地理编码、公交换乘分析等'
        },
        {
          id: 6,
          title: '互联网地图在线集成',
          content: '实时调用集成谷歌、高德、百度等互联网地图，以统一的接口提供开发应用'
        },
        {
          id: 7,
          title: '互联网地图离线应用',
          content: '离线集成谷歌、高德、百度等互联网地图数据，集成到本地ZTMapGIS平台，实现本地化地图应用'
        },
        {
          id: 8,
          title: '室内地图应用',
          content: '实现商场、展览馆、停车场等室内地图的绘制、渲染、导航、人流分析等功能'
        },
        {
          id: 9,
          title: '大数据应用',
          content: '能够无缝对接Hadoop、Spark等主流大数据平台，兼容HDFS、HBase、Hive等大数据主流数据协议和接口'
        },
        {
          id: 10,
          title: 'AI（人工智能）应用',
          content: '将聚类算法、回归算法、卷积网络等主流AI算法的理念和算法能力应用于空间数据分析中，以AI为空间信息应用赋能'
        },
        {
          id: 11,
          title: 'VR/AR集成应用',
          content: '结合GIS空间渲染和三维渲染的技术优势，融入AR技术，实现增强现实的行业应用'
        }
      ],
    }
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/product/${fileName}`);
    }
  },
  mounted: function () {}
}
</script>

<style lang="less" scoped>
//scoped
.productBanner {
  .img {
    background-image: url("../../assets/images/index/banner_img1.png");
  }
}
.product1 {
  .function {
    margin-top: 100px;
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
    }
    .functionbg {
      background: url("../../assets/images/product/bg1.png") no-repeat center
        center / cover;
      .list {
        font-size: 0;
        padding-bottom: 68px;
        > div {
          display: inline-block;
          width: 33.33%;
          padding-top: 68px;
          vertical-align: top;
          .left {
            font-size: 40px;
            color: rgba(223, 223, 223, 1);
            float: left;
          }
          .right {
            float: right;
            width: 300px;
            padding: 0 25px;
            .title {
              font-size: 20px;
              color: rgba(75, 75, 75, 1);
              line-height: 28px;
              margin-bottom: 10px;
            }
            .p {
              font-size: 14px;
              color: rgba(124, 124, 124, 1);
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .rendering {
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 100px;
    }
    .list {
      > div {
        width: 584px;
        height: 384px;
        font-size: 0;
        display: inline-block;
        background: #ccc;
        margin-right: 20px;
        margin-bottom: 20px;
        background: no-repeat center center/100% 100%;
        &:nth-child(1) {
          background-image: url("../../assets/images/product/product1-1.jpg");
        }
        &:nth-child(2) {
          background-image: url("../../assets/images/product/product1-2.jpg");
        }
        &:nth-child(3) {
          background-image: url("../../assets/images/product/product1-3.jpg");
        }
        &:nth-child(4) {
          background-image: url("../../assets/images/product/product1-4.jpg");
        }
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
  .characteristics {
    margin-bottom: 100px;
    background: none;
    height: auto;
    .productTitle {
      text-align: center;
      margin-bottom: 60px;
      margin-top: 80px;
    }
    .characteristicsbg {
      height: 502px;
      background: url("../../assets/images/product/bg2.png") no-repeat center
        center / cover;
      overflow: hidden;
      .module {
        margin-top: 105px;
        > div {
          display: flex;
          > div {
            flex: 1;
          }
          &:nth-child(2n + 1) {
            height: 65px;
            line-height: 65px;
            > div {
              vertical-align: middle;
              font-size: 24px;
              color: #4b4b4b;
            }
          }
          &:nth-child(2n) {
            height: 49px;
            > div {
            }
          }
        }
        .y {
          width: 18px;
          height: 18px;
          background: #0276f7;
          border-radius: 50%;
          display: inline-block;
          margin-right: 20px;
        }
        .x {
          width: 2px;
          height: 49px;
          background: #0276f7;
          display: inline-block;
          margin-left: 9px;
        }
      }
    }
  }
  .application {
    margin-bottom: 127px;
    .productTitle {
      text-align: center;
      margin-bottom: 39px;
    }
    .list {
      font-size: 0;
      > div {
        width: 280px;
        height: 269px;
        display: inline-block;
        background: #ccc;
        margin-right: 26px;
        margin-bottom: 31px;
        vertical-align: top;
        writing-mode: lr-tb;
        font-size: 12px;
        padding: 42px 111px 0 144px;
        box-sizing: border-box;
        font-size: 30px;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
        cursor: pointer;
        position: relative;
        .c {
          position: absolute;
          font-size: 30px;
          line-height: 30px;
          bottom: 38px;
          left: 38px;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(1),
        &:nth-child(8) {
          background: url("../../assets/images/product/application_bg1.png")
            no-repeat center center/100% 100%;
          .c {
            color: #70b4ff;
          }
        }
        &:nth-child(2),
        &:nth-child(7) {
          background: url("../../assets/images/product/application_bg2.png")
            no-repeat center center/100% 100%;
          .c {
            color: #f895a4;
          }
        }
        &:nth-child(3),
        &:nth-child(6) {
          background: url("../../assets/images/product/application_bg3.png")
            no-repeat center center/100% 100%;
          .c {
            color: #ffd28e;
          }
        }
        &:nth-child(4),
        &:nth-child(5) {
          background: url("../../assets/images/product/application_bg4.png")
            no-repeat center center/100% 100%;
          .c {
            color: #a8efa3;
          }
        }
      }
    }
  }
}
.mobile-product1 {
  display: none;
  flex-direction: column;
  font-family: 'Normal';
  .product-title {
    width: 100%;
    height: 28rem;
    background: linear-gradient(180deg, #3374EF 0%, #9DCFFF 100%);
    box-sizing: border-box;
    padding: 8rem 0 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: white;
    .title-content {
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .line {
        width: 4rem;
        height: 0.2rem;
        background: #FFFFFF;
        margin-top: 1rem;
      }
      .p {
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 2rem;
      }
      .span {
        width: 15rem;
        margin-top: 1rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.6rem;
      }
    }
    .img {
      flex-grow: 1;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .overview-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .overview-content {
      font-size: 1rem;
      font-weight: 350;
      line-height: 2rem;
      color: #3D3D3D;
      text-align: left;
      text-indent: 2em;
      margin-top: 2rem;
      color: #333333;
    }
  }
  .function {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      .item {
        width: 47.5%;
        box-sizing: border-box;
        padding: 2rem 1.5rem 1.5rem 1.5rem;
        background: rgba(255, 255, 255, 0.5);
        font-family: 'Normal';
        margin-top: 1.5rem;
        text-align: left;
        >p {
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
        }
        >span {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          margin-top: 2rem;
          color: #333333;
          
        }
      }
    }
  }
  .rendering {
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem 0;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .swiper {
      margin-top: 2rem;
    }
  }
  .characteristics {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem;
    height: 36rem;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding-top: 2rem;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        display: flex;
        flex-direction: column;
        background: rgba(255, 255, 255, .5);
        box-sizing: border-box;
        padding: 0 0.5rem;
        margin-top: 1rem;
        div {
          display: flex;
          align-items: center;
          >p {
            font-size: 1.2rem;
            font-weight: bold;
            color: #999999;
          }
          >span {
            margin-left: 0.5rem;
            font-size: 1rem;
            font-weight: 350;
          }
        }
      }
      .item3 {
        display: flex;
        flex-direction: column;
        background: rgba(255, 255, 255, .5);
        box-sizing: border-box;
        padding: 0 0.5rem;
        margin-top: 1rem;
        div {
          display: flex;
          align-items: center;
          >p {
            font-size: 1.2rem;
            font-weight: bold;
            color: #999999;
          }
          >span {
            margin-left: 0.5rem;
            font-size: 1rem;
            font-weight: 350;
          }
        }
      }
    }
  }
  .part {
    .application-content {
      width: 100%;
      height: 25rem;
      margin-top: 2rem;
      font-family: 'Normal';
      position: relative;
      margin-left: -1rem;
      .item {
        width: 9.5rem;
        height: 9.5rem;
        clip-path: polygon(25% 0%, 75% 0%, 100% 44%, 75% 88%, 25% 88%, 0% 44%);
        font-size: 1.4rem;
        font-weight: bold;
        line-height: 8.36rem;
        text-align: center;
        color: #fff;
      }
      .item1 {
        background: rgba(60, 128, 232, 0.5);
        position: absolute;
        top: 0;
        left: 0;
      }
      .item2 {
        background: rgba(60, 128, 232, 0.8);
        position: absolute;
        top: 0;
        left: 50%;
      }
      .item3 {
        background: rgba(60, 128, 232, 0.6);
        position: absolute;
        top: 20%;
        left: 25%;
      }
      .item4 {
        background: rgba(60, 128, 232, 0.7);
        position: absolute;
        top: 20%;
        left: 75%;
      }
      .item5 {
        background: rgba(60, 128, 232, 0.4);
        position: absolute;
        top: 37.5%;
        left: 0%;
      }
      .item6{
        background: rgba(60, 128, 232, 0.5);
        position: absolute;
        top: 37.5%;
        left: 50%;
      }
      .item7 {
        background: rgba(60, 128, 232, 0.7); 
        position: absolute;
        top: 57.5%;
        left: 25%; 
      }
      .item8 {
        background: rgba(60, 128, 232, 0.8); 
        position: absolute;
        top: 57.5%;
        left: 75%; 
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .productBanner {
    display: none !important;
  }
  .product1 {
    display: none;
  }
  .mobile-product1 { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product1.vue